export default {
  page: {
    title: 'Configurações',
    subtitle: 'Sistema',
  },
  tabs: {
    company: 'Dados da empresa',
    messages: 'Textos dos impressos',
    settings: 'Variáveis do sistema',
    accessControl: 'Controle de acesso',
  },
  accessControl: {
    tabs: {
      roles: 'Tipos',
      modules: 'Módulos',
      users: 'Usuários',
    },
  },
  company: {
    form: {
      name: {
        label: 'Nome',
        placeholder: 'Nome',
      },
      bgColor: {
        label: 'Cor de fundo',
        hint: 'pdf',
        placeholder: 'Fundo',
      },
      fontColor: {
        label: 'Cor fonte (padrão)',
        hint: 'pdf',
        placeholder: 'Fonte',
      },
      fontColor2: {
        label: 'Cor fonte',
        hint: 'pdf',
        placeholder: 'Fonte',
      },
      titleColor: {
        label: 'Cor do título',
        hint: 'pdf',
        placeholder: 'Fundo',
      },
      cnpj: {
        label: 'CNPJ',
        placeholder: '00.000.000/0000-00',
      },
      email: {
        label: 'Email',
        placeholder: 'E-mail',
      },
      site: {
        label: 'Site',
        placeholder: 'Site',
      },
      instagram: {
        label: 'Instagram',
        placeholder: 'Instagram',
      },
      whatsapp1: {
        label: 'Telefone 1 Whatsapp',
      },
      whatsapp2: {
        label: 'Telefone 2 Whatsapp',
      },
      phone: {
        label: 'Telefone Fixo',
        placeholder: 'Telefone',
      },
      address: {
        label: 'Endereço',
        placeholder: 'Rua,Av,Travessa',
      },
      number: {
        label: 'Número',
        placeholder: 'Número',
      },
      district: {
        label: 'Bairro',
      },
      city: {
        label: 'Cidade',
      },
      state: {
        label: 'Estado',
      },
      zipcode: {
        label: 'CEP',
        placeholder: '00.000-000',
      },
    },
  },
  messages: {
    form: {
      slogan: {
        label: 'Slogan',
        hint: 'Abaixo do nome da empresa',
        placeholder: 'Lista abaixo do logo nos pdfs',
      },
      receipt: {
        label: 'Mensagem do recibo',
      },
      warranty: {
        label: 'Mensagem da Garantia',
      },
      approbation: {
        label: 'Mensagem da Vistoria',
      },
      sendMessage: {
        label: 'Mensagem de envio',
        hintEmail: '(corpo do e-mail)',
        hintWhatsapp: '(corpo do whatsapp)',
      },
      footer: {
        label: 'Mensagem Rodapé',
      },
    },
  },
  settings: {
    form: {
      warranty: {
        label: 'Tempo de Garantia Padrão',
        placeholder: 'Ano, mês, dias',
      },
      timeAlert: {
        label: 'Tempo Alerta ao cliente',
        placeholder: 'Tempo de espera em dias',
      },
      logo: {
        label: 'Logo',
        chooseFile: 'Escolha uma imagem...',
      },
    },
  },
  roles: {
    card: {
      title: 'Lista de tipos de usuários',
    },
    placeholder: 'Adicione um novo departamento',
  },
  permissions: {
    form: {
      roles: {
        label: 'Tipos de usuário',
      },
    },
    card: {
      title: 'Lista de Módulos',
    },
    empty: 'Selecione um departamento',
    yes: 'Sim',
  },
  users: {
    card: {
      title: 'Lista de Usuários',
    },
    selectRole: 'Selecione um departamento',
    noContent: 'Nenhum usuário cadastrado ainda.',
  },
  alert: {
    companySaved: 'Configurações salvas com sucesso',
    messagesSaved: 'Mensagens salvas com sucesso',
    settingsSaved: 'Variáveis salvas com sucesso',
    roleSaved: 'Departamento salvo com sucesso',
    roleChanged: 'Departamento alterado com sucesso',
    permissionsSaved: 'Permissões salvas com sucesso',
  },
};
